import React from 'react';
import { useResponsive } from '../hooks/useResponsive';
import BottomNav from './BottomNav';

const API = process.env.REACT_APP_API_URL || 'https://lacasadelpuro-pos-production.up.railway.app';
const GOLD = '#C9A84C';
const SURFACE = '#1A1A1A';
const BORDER = '#2A2A2A';

const BTN_VIEWS = [
  { label: '🧾 POS',       view: 'pos'       },
  { label: '📋 History',   view: 'history'   },
  { label: '👥 Members',   view: 'members'   },
  { label: '📦 Receiving', view: 'receiving' },
  { label: '📊 Revenue Intelligence',   view: 'taxreport'  },
  { label: '📣 Marketing', view: 'marketing' },
  { label: 'Cigar Intelligence', view: 'cigars' },
  { label: '⚙️ Admin',     view: 'admin'     },
];

export default function GlobalNav({ staff, currentView, nav }) {
  const { isMobile } = useResponsive();

  const handleNav = (view) => {
    if (view === 'logout')   nav.onLogout();
    else if (view === 'pos')       nav.onPos();
    else if (view === 'history')   nav.onHistory();
    else if (view === 'members')   nav.onMembers();
    else if (view === 'receiving') nav.onReceiving();
    else if (view === 'taxreport') nav.onReports();
    else if (view === 'admin')     nav.onAdmin();
    else if (view === 'cigars')    nav.onCigars();
    else if (view === 'marketing') nav.onMarketing();
  };

  const bottomTab = {
    pos: 'pos', history: 'reports', members: 'members',
    receiving: 'inventory', taxreport: 'reports', marketing: 'marketing', admin: 'settings', cigars: 'reports',
  }[currentView] || 'pos';

  return (
    <>
      <div style={{
        background: SURFACE, borderBottom: `1px solid ${BORDER}`,
        padding: isMobile ? '0 12px' : '0 20px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        height: isMobile ? 56 : 80, flexShrink: 0,
        position: 'sticky', top: 0, zIndex: 200, gap: 12,
      }}>
        <img
          onClick={nav.onPos}
          src={process.env.REACT_APP_LOUNGE_LOGO}
          alt="Lounge logo"
          style={{
            height: isMobile ? 'var(--logo-height-mobile)' : 'var(--logo-height-desktop)',
            width: 'auto', cursor: 'pointer', flexShrink: 0, display: 'block',
          }}
        />
        {!isMobile && (
          <div style={{ display: 'flex', gap: 4, flexWrap: 'nowrap', alignItems: 'center', overflowX: 'auto', minWidth: 0 }}>
            {BTN_VIEWS.map((btn) => {
              const isActive = btn.view === currentView;
              return (
                <button key={btn.view} onClick={() => handleNav(btn.view)} style={{
                  background: isActive ? GOLD : '#2A2A2A', border: `1px solid ${isActive ? GOLD : '#3A3A3A'}`,
                  borderRadius: 8, color: isActive ? '#000' : '#CCC', padding: '6px 8px',
                  cursor: 'pointer', fontSize: 10.5, fontFamily: 'Georgia',
                  fontWeight: isActive ? 700 : 400, minHeight: 44, whiteSpace: 'nowrap', transition: 'all 0.15s', flexShrink: 0,
                }}>{btn.label}</button>
              );
            })}
          </div>
        )}
        {isMobile && <span style={{ color: '#666', fontSize: 11, whiteSpace: 'nowrap' }}>👤 {staff?.name}</span>}
      </div>
      {isMobile && (
        <BottomNav activeTab={bottomTab} onChange={(tab) => {
          if (tab === 'pos')       nav.onPos();
          if (tab === 'members')   nav.onMembers();
          if (tab === 'inventory') nav.onReceiving();
          if (tab === 'reports')   nav.onReports();
          if (tab === 'marketing') nav.onMarketing();
          if (tab === 'settings')  nav.onAdmin();
        }} />
      )}
      {!isMobile && (
        <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, textAlign: 'center', background: '#000', zIndex: 9999, lineHeight: 0, pointerEvents: 'none' }}>
          <img src={API + '/images/puroai-logo.png'} alt="Powered by Puro POS" style={{ height: 80, width: 'auto', opacity: 0.97 }} />
        </div>
      )}
      {isMobile && (
        <div style={{ position: 'fixed', bottom: `calc(56px + env(safe-area-inset-bottom) + 4px)`, left: 0, right: 0, textAlign: 'center', zIndex: 890, pointerEvents: 'none', lineHeight: 0 }}>
          <img src={API + '/images/puroai-logo.png'} alt="Powered by Puro POS" style={{ height: 36, width: 'auto', opacity: 0.55 }} />
        </div>
      )}
    </>
  );
}
